import { parsePlaceholders } from '../template-engine';
import sites from '../../data/sites.json';
var getSite = function getSite(siteId) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var availableSites = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : sites;
  var currentSite = siteId && availableSites.find(function (site) {
    return siteId === site.id;
  });
  if (!currentSite) {
    return currentSite;
  }
  return parsePlaceholders(currentSite, {
    config: config.serverRuntimeConfig
  });
};
export default getSite;